import { useQuery } from '@tanstack/react-query';
import { default as addressService } from "../services/address";
import useLangs from '@/languages/hooks/useLangs';

export const useTipovias = () => {
  const { currentLang } = useLangs()

  return useQuery({
    queryKey: ['tipovias', currentLang],
    queryFn: () => addressService.fetchTipovias(),
    staleTime: 1000 * 60 * 30
  })
  
}